import { Dispatch, FC, SetStateAction } from 'react'

import { ClientPropertySelfUploadPopupContext } from './ClientPropertySelfUploadPopup.context'
import { ClientPropertySelfUploadPopupController } from './ClientPropertySelfUploadPopup.controller'
import { DynamicFlowProvider } from 'components/common/DynamicFlow'
import { VisualFileType } from 'constants/visual'
import { useParams } from 'react-router-dom'

/**
 * @interface Props
 */
interface Props {
  /** Whether the upload popup is opened */
  isUploadPopupOpened: boolean
  /** Function to set the upload popup state */
  setIsUploadPopupOpened: Dispatch<SetStateAction<boolean>>
  /** Normalized original type of the visual */
  normalizedOriginalType: VisualFileType
}


/**
 * @component ClientPropertySelfUploadPopup 
 * @example
 * <ClientPropertySelfUploadPopup />
 */
export const ClientPropertySelfUploadPopup: FC<Props> = ({
  isUploadPopupOpened,
  setIsUploadPopupOpened,
  normalizedOriginalType,
}) => {
  const { id } = useParams<{ id?: string }>() // TODO: Will be updated when BE is ready

  if (!id) return null

  return (
    <DynamicFlowProvider>
      <ClientPropertySelfUploadPopupContext assignmentId={id}>
        <ClientPropertySelfUploadPopupController
          isUploadPopupOpened={isUploadPopupOpened}
          setIsUploadPopupOpened={setIsUploadPopupOpened}
          normalizedOriginalType={normalizedOriginalType}
        />
      </ClientPropertySelfUploadPopupContext>
    </DynamicFlowProvider>
  )
}
